/**
 * PowersureLandingFinalCTA — dark afsluitende CTA voor landing.
 *
 * P0 Flow-fix (Feb 2026):
 *   CTA gaat NIET meer naar `/energy-control-intake` (vragen). De primaire
 *   actie is "Start Mijn Powersure" → directe Stripe Checkout. Setup-vragen
 *   gebeuren pas in `/app` na aankoop.
 */
import { Zap } from 'lucide-react';
import PowersureCard from '@/components/powersure-ui/PowersureCard';
import { psCls } from '@/lib/powersure-theme';
import LandingPrimaryCta from '@/components/home/LandingPrimaryCta';

export default function PowersureLandingFinalCTA() {
  return (
    <section
      className="py-10 sm:py-14"
      style={{ background: 'linear-gradient(180deg, #0e1b16 0%, #0a1410 100%)' }}
      data-testid="final-cta-section"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <PowersureCard className="max-w-2xl mx-auto text-center" padding="p-6 sm:p-10">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className={psCls.iconBadge}>
              <Zap className="w-4 h-4" />
            </span>
            <span className={psCls.label}>Start vandaag</span>
          </div>
          <h2
            className="text-2xl sm:text-3xl font-medium text-white leading-tight"
            style={{ fontFamily: 'Outfit' }}
          >
            Klaar om uw zonnestroom slimmer te benutten?
          </h2>
          <p className="text-sm sm:text-[15px] text-white/70 mt-3 max-w-xl mx-auto leading-relaxed">
            Start direct uw abonnement. Uw setup en apparaten doet u rustig in
            Mijn Powersure nadat u de app heeft geopend — geen vragenformulier
            vooraf.
          </p>
          <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center max-w-md mx-auto">
            <LandingPrimaryCta
              ctaId="final_cta_subscription"
              label="Start Mijn Powersure"
              testId="final-cta-start-btn"
            />
          </div>
          <p className="text-[12px] text-white/55 mt-4">
            € 9,95 per maand · eerste 3 maanden, daarna € 14,95 per maand · maandelijks opzegbaar
          </p>
        </PowersureCard>
      </div>
    </section>
  );
}
